export default "__VITE_ASSET__BBeJmyHl__"